import {
   ChangeDetectionStrategy,
   ChangeDetectorRef,
   Component,
   EventEmitter,
   Input,
   OnChanges,
   Output,
   SimpleChanges,
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { CallState } from '@lcs/shared/api';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { LcsDialogService } from 'src/app/common-components/dialog/dialog.service';
import { ParameterFormValueUnion } from '../report-parameter-list/models/report-parameter-form-value';
import { ReportParameterFormService } from '../report-parameter-list/services/report-parameter-form.service';
import { ReportService } from '../services/report.service';
import {
   selectCurrentReportCallState,
   selectCurrentReportContextHelpIds,
   selectCurrentReportFormValue,
   selectCurrentReportName,
} from '../state/reports.reducer';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ndt-report-parameters',
    templateUrl: './report-parameters.component.html',
    standalone: false
})
// eslint-disable-next-line @typescript-eslint/naming-convention
export class ReportParametersComponent<P extends { viewMode?: any }> implements OnChanges {
   @Input() formService: ReportParameterFormService<P>;

   @Output() remove = new EventEmitter<never>();

   form: UntypedFormGroup;

   loading$: Observable<CallState>;

   reportName$: Observable<string>;

   contextHelpIds$: Observable<number[]>;

   constructor(
      private store: Store,
      private reportService: ReportService<P, any>,
      private cd: ChangeDetectorRef,
      private dialogService: LcsDialogService
   ) {
      this.loading$ = store.pipe(select(selectCurrentReportCallState));
      this.reportName$ = store.pipe(select(selectCurrentReportName));
      this.contextHelpIds$ = store.pipe(select(selectCurrentReportContextHelpIds));
   }

   ngOnChanges(changes: SimpleChanges): void {
      if (changes.formService && this.formService) {
         this.form = this.formService.form;

         this.store
            .pipe(select(selectCurrentReportFormValue), take(1))
            .subscribe((value: ParameterFormValueUnion[] | null) => {
               if (value) {
                  this.formService.setValue(value);
               }
            });
      }
   }

   onSubmit(): void {
      if (this.form.valid || this.formService.form.valid) {
         const parameters = this.formService.getValue(true);
         if (parameters) {
            this.reportService.onSubmit(this.form.getRawValue(), parameters);
         }
      } else {
         this.formService.form.markAllAsTouched();
         this.formService.form.updateValueAndValidity();
         this.cd.detectChanges();
      }
   }

   onCloseClick() {
      this.dialogService.close();
   }
}
